import { Suspense } from "react";
import { Navigate, Outlet } from "react-router";

import { ChunkLoadErrorBoundary, Loader } from "@/components/commons";

/** Full-page spinner for public routes (login, signup, etc.) */
const PublicPageLoader = () => <Loader />;

const PublicRoute = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
  return isLoggedIn ? (
    <Navigate
      to="/"
      replace
    />
  ) : (
    <ChunkLoadErrorBoundary>
      <Suspense fallback={<PublicPageLoader />}>
        <Outlet />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};

export default PublicRoute;
